module.exports = __webpack_public_path__ + "3f7b0bc700d91f0243588e14b5613735.pdf";